export default {
  "HitPaw Online Audio Joiner": "HitPaw Online Audio Joiner",
  "Merge Audio": "Audio zusammenführen",
  "Merge multiple audio tracks into one.": "Mehrere Audiotrack zu einer zusammenführen.",
  "Merge New": "Neu zusammenführen",
  "Merge failed": "Zusammenführen ist fehlgeschlagen",
  "Fade in": "Einblenden",
  "Fade out": "Ausblenden",
  "Add tracks": "Tracks hinzufügen",
  "Format": "Format",
};
